const makeConstant = constant => `conversation/${constant}`

export const UPDATE_INBOX = makeConstant('UPDATE_INBOX')
export const UPDATE_INBOX_SUCCESS = makeConstant('UPDATE_INBOX_SUCCESS')
export const UPDATE_INBOX_PENDING = makeConstant('UPDATE_INBOX_PENDING')
export const UPDATE_INBOX_FAILED = makeConstant('UPDATE_INBOX_FAILED')
